"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedIntentURL = void 0;
function IntentURL(amount, login) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (login === void 0) { login = false; }
    var form = document.getElementById('donation-form');
    var searchParams = new URLSearchParams(window.location.search);
    if ((amount).toString().indexOf('.') !== -1) {
        amount = Math.round(amount * 100);
    }
    if (login) {
        var intentURL = '/api/donations/loginIntent?amount=' + amount;
    }
    else {
        var intentURL = '/api/donations/intent?amount=' + amount;
    }
    var comment1 = (_a = form.getAttribute('comment1')) !== null && _a !== void 0 ? _a : searchParams.get('comment1');
    if (comment1) {
        intentURL += '&comment1=' + encodeURIComponent(comment1);
    }
    var comment2 = (_b = form.getAttribute('comment2')) !== null && _b !== void 0 ? _b : searchParams.get('comment2');
    if (comment2) {
        intentURL += '&comment2=' + encodeURIComponent(comment2);
    }
    var comment3 = (_c = form.getAttribute('comment3')) !== null && _c !== void 0 ? _c : searchParams.get('comment3');
    if (comment3) {
        intentURL += '&comment3=' + encodeURIComponent(comment3);
    }
    var type = (_d = form.getAttribute('type')) !== null && _d !== void 0 ? _d : searchParams.get('type');
    if (type) {
        intentURL += '&type=' + encodeURIComponent(type);
    }
    var email = (_e = form.getAttribute('email')) !== null && _e !== void 0 ? _e : searchParams.get('email');
    if (email) {
        intentURL += '&email=' + encodeURIComponent(email);
    }
    var origin = (_f = form.getAttribute('origin')) !== null && _f !== void 0 ? _f : searchParams.get('origin');
    if (origin) {
        intentURL += '&origin=' + encodeURIComponent(origin);
    }
    var lang = (_h = (_g = form.getAttribute('lang')) !== null && _g !== void 0 ? _g : searchParams.get('lang')) !== null && _h !== void 0 ? _h : 'en';
    if (lang) {
        intentURL += '&lang=' + encodeURIComponent(lang);
    }
    return intentURL;
}
exports.default = IntentURL;
function SavedIntentURL(amount, payment_method_id, return_url) {
    var _a, _b, _c, _d, _e, _f, _g;
    var form = document.getElementById('donation-form');
    var searchParams = new URLSearchParams(window.location.search);
    var intentURL = '/api/donations/loginIntent?payment_method_id=' + payment_method_id + "&return_url=" + encodeURIComponent(return_url) + '&amount=' + amount;
    var comment1 = (_a = form.getAttribute('comment1')) !== null && _a !== void 0 ? _a : searchParams.get('comment1');
    if (comment1) {
        intentURL += '&comment1=' + encodeURIComponent(comment1);
    }
    var comment2 = (_b = form.getAttribute('comment2')) !== null && _b !== void 0 ? _b : searchParams.get('comment2');
    if (comment2) {
        intentURL += '&comment2=' + encodeURIComponent(comment2);
    }
    var comment3 = (_c = form.getAttribute('comment3')) !== null && _c !== void 0 ? _c : searchParams.get('comment3');
    if (comment3) {
        intentURL += '&comment3=' + encodeURIComponent(comment3);
    }
    var type = (_d = form.getAttribute('type')) !== null && _d !== void 0 ? _d : searchParams.get('type');
    if (type) {
        intentURL += '&type=' + encodeURIComponent(type);
    }
    var email = (_e = form.getAttribute('email')) !== null && _e !== void 0 ? _e : searchParams.get('email');
    if (email) {
        intentURL += '&email=' + encodeURIComponent(email);
    }
    var origin = (_f = form.getAttribute('origin')) !== null && _f !== void 0 ? _f : searchParams.get('origin');
    if (origin) {
        intentURL += '&origin=' + encodeURIComponent(origin);
    }
    // Subscription-cart orders carry structured pricing, shipping, and note
    // fields. The server recomputes the authoritative amount from the
    // structured fields (SubscriptionPriceService) and rejects the intent as
    // unpriceable without them, so the saved-card path must forward them the
    // same way the new-card path does. Absent on plain donation forms.
    var subscriptionKeys = [
        'disc_year', 'disc_rate', 'disc_format', 'sat_rate', 'gift_months',
        'ship_first_name', 'ship_last_name', 'ship_address_1', 'ship_address_2',
        'ship_city', 'ship_state', 'ship_postcode', 'ship_country', 'ship_fee', 'ship_tax',
    ];
    for (var _i = 0, subscriptionKeys_1 = subscriptionKeys; _i < subscriptionKeys_1.length; _i++) {
        var key = subscriptionKeys_1[_i];
        var value = (_g = form.getAttribute(key)) !== null && _g !== void 0 ? _g : searchParams.get(key);
        if (value) {
            intentURL += "&".concat(key, "=") + encodeURIComponent(value);
        }
    }
    return intentURL;
}
exports.SavedIntentURL = SavedIntentURL;
